import { Section } from 'services/api/vehicle-sections/types';
import { useLevel1SectionData } from './useLevel1Section';

export const usePowerEquipmentSection = (): Section | undefined => {
  const { subSections } = useLevel1SectionData('interior_questions');
  return subSections.power_equipment_checked as Section | undefined;
};
